<form
  #ngForm="ngForm"
  [formGroup]="renderedFormService.formGroup"
  (ngSubmit)="ngForm.form.valid && submitForm()"
  [class.ng-submitted]="ngForm.submitted"
>
  <fl-form-section
    *ngFor="let section of visibleSections"
    [forceReadonly]="forceReadonly"
    [form]="form"
    [section]="section"
    [sectionForms]="sectionForms"
  ></fl-form-section>

  <fl-message-box
    *ngIf="userHasClickedSubmit && isAnySectionInvalid"
    [type]="messageBoxType.Alert"
  >
    <p>It looks like you missed a required field. Be sure to complete anything highlighted in red above.</p>
  </fl-message-box>

  <div class="footer flex-container">
    <button
      [disabled]="isSubmitting$ | async"
      class="flex-cell"
      color="primary"
      mat-raised-button
    >
      {{ ctaLabel }}
    </button>
  </div>
</form>
